module.exports = __webpack_public_path__ + "img/password-four.3079518b.png";